import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtomsModule } from './atoms';
import { MoleculesModule } from './molecules';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  imports: [AtomsModule, MoleculesModule, CommonModule, DirectivesModule],
  exports: [AtomsModule, MoleculesModule],
})
export class ElementsModule {}
